"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M47.423 13.443s-.467-3.294-1.9-4.745a6.838 6.838 0 0 0-4.79-2.025c-6.689-.483-16.722-.483-16.722-.483h-.021s-10.033 0-16.722.483A6.838 6.838 0 0 0 2.478 8.7c-1.433 1.451-1.9 4.745-1.9 4.745A72.223 72.223 0 0 0 .1 21.179v3.626a72.223 72.223 0 0 0 .478 7.736s.466 3.294 1.9 4.745c1.818 1.9 4.207 1.844 5.27 2.043C11.573 39.7 24 39.81 24 39.81s10.044-.015 16.733-.5a6.835 6.835 0 0 0 4.79-2.024c1.433-1.451 1.9-4.745 1.9-4.745a72.368 72.368 0 0 0 .477-7.736v-3.626a72.368 72.368 0 0 0-.477-7.736zm-28.39 16.044L19.03 16 32 22.767z" })
);

